<template>
  <v-container fluid class="px-0">
    <v-card>
      <v-card-text>
        <h4 class="mb-2 paieska-title">Paieška</h4>
        <form @keydown.enter.prevent="submit()">
          <v-row class="mb-3">
            <v-col cols="12" md="4">
              <el-text-field
                label="Ataskaitos Nr."
                tooltip="Ataskaita. Paieška. Ataskaitos Nr."
                v-model="extraData.ata_id"
              />
            </v-col>
            <v-col cols="12" md="4">
              <el-date-picker
                label="Ataskaitos suformavimo data nuo"
                tooltip="Ataskaita. Paieška. Ataskaitos suformavimo data nuo"
                v-model="extraData.ata_sukurimo_data_nuo"
              />
            </v-col>
            <v-col cols="12" md="4">
              <el-date-picker
                label="Ataskaitos suformavimo data iki"
                tooltip="Ataskaita. Paieška. Ataskaitos suformavimo data iki"
                v-model="extraData.ata_sukurimo_data_iki"
              />
            </v-col>
            <template v-if="isRegistrams">
              <v-col cols="12" md="3">
                <el-autocomplete
                  :items="registrasTipasList"
                  itemvalue="value"
                  itemtext="text"
                  label="Susijusio registro objektas"
                  tooltip="Ataskaita. Paieška. Susijusio registro objektas"
                  v-model="extraData.tipas"
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-text-field
                  label="Ataskaitą suformavo"
                  tooltip="Ataskaita. Paieška. Ataskaitą suformavo"
                  v-model="extraData.suformavo"
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-autocomplete
                  :items="registrasRezultatasList"
                  itemvalue="value"
                  itemtext="text"
                  label="Rezultatas"
                  tooltip="Ataskaita. Paieška. Rezultatas"
                  v-model="extraData.rezultatas"
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-text-field
                  label="DVS Nr."
                  tooltip="Ataskaita. Paieška. DVS Nr."
                  v-model="extraData.ata_dvs_nr"
                />
              </v-col>
            </template>
          </v-row>

          <v-row no-gutters>
            <v-col cols="12">
              <el-button
                primary
                :loading="loading"
                @click.native.stop="searchData()"
              >
                Ieškoti
              </el-button>
              <el-button :loading="loading" @click.native="clearData()">
                Išvalyti
              </el-button>
            </v-col>
          </v-row>
        </form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import registrasTipasList from './registrasTipasList'

export default {
  name: 'AtaskaitaSearch',
  props: {
    loading: Boolean,
    tabItem: Object,
  },
  mixins: [registrasTipasList],
  data: () => ({
    searchPanel: null,
    mainData: {},
    extraData: {},
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      return this.searchPanel === 0
    },
    isRegistrams() {
      return this.tabItem.tipas === 'registrams'
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      // if (this.tabItem.statistika) {
      //   this.extraData.tipas = this.tabItem.tipas
      // }
      if (this.isRegistrams) {
        this.extraData.rezultatas = 2
      }
      this.searchData()
    },
    searchData() {
      let searchData = this.extraData

      this.$emit('search', searchData)
    },
    clearData() {
      this.extraData = {
        ata_id: null,
        ata_sukurimo_data_nuo: null,
        ata_sukurimo_data_iki: null,
        tipas: null,
        rezultatas: null,
        suformavo: null,
        ata_dvs_nr: null,
      }
    },
    submit() {
      this.searchData()
    },
  },
}
</script>
<style lang="scss" scoped>
.paieska-title {
  font-weight: 400;
}
</style>
